/**
 * User class
 */
export class User {
    public accountId: number;
    public companyId: number;
    public workplaceId: any;
    public id: string;
    public status: boolean;
    public name: string;
    public surname: string = '';
    public loggedStatus: string = '';
    public workStatus: string = '';
    public employeeType: string = '';
    public user_email: string = '';
    public user_birthday: string = '';
    public last_four:string = '';
    public phone:string = '';
    public adress:string = '';
    public civilRegistrationNumber:string = '';
    public hasPinCode:boolean;
    public requireUserPincode:boolean;
    public userLastIdNumbersAsPincode:boolean;
    public post_number:string = '';
    public city:string = '';
    public timecorrection: boolean;
    public useLunch: boolean = false;
    public useBreakfast: boolean = false;
    public userErrors: any;
    public pictureUrl: string = './assets/imgs/face.jpg';
    public totalWorkedHours: number;
    public checkInDate : string; // Original
    public checkInTime : string; // Original
    public originalCheckInDateTime : Date;
    public checkOutDate : string; // Original
    public checkOutTime : string; // Original
    public originalCheckOutDateTime : Date;
    public breaks : Array<{}>;
    public events: Array<{}>;
    public todaysShifts: Array<{}>;
    public adjustedCheckInDateTime : Date;
    public adjustedCheckOutDateTime : Date;
    public regId : number;
    public regIdEnd : number;
    public automaticMealBenefitRegistration: boolean;
    public notifications: Array<{}>;
    public canTakeBreak: boolean;
    public useScheduleBreak: boolean;
    public timereg_workplace_id: number;
    public forceWorkplaceCheckout: boolean;

    /**
     *
     * @param {string} id
     * @param {boolean} status
     * @param {string} name
     * @param {string} surname
     */
    constructor(id: string, status: boolean, name: string, surname: string) {
        this.id = id;
        this.status = status;
        this.name = name;
        this.surname = surname;
        this.events = new Array<{}>();
    }
}



// WEBPACK FOOTER //
// ./src/models/user.ts